import React from "react";

// Overlay générique pour afficher un formulaire (ex: NouveauContactForm) par-dessus
// un autre overlay déjà ouvert — z-index élevé + fond propre, indépendant de
// la classe globale `overlayAC` utilisée pour les fiches.
export default function FormOverlay({ onClose, children }) {
  return (
    <div
      className="fixed inset-0 z-[9999] bg-black/40 flex items-center justify-center"
      style={{ paddingLeft: "var(--sidebar-width, 0px)" }}
      onClick={onClose}
    >
      <div
        className="relative bg-white w-[90%] max-w-[860px] rounded-2xl overflow-hidden shadow-2xl"
        style={{ height: "85vh" }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
